<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          published
          <a
            class="resource-link"
            :href="activity.source.book.url"
            :title="activity.source.book.title"
            @click.stop
          >
            a review
          </a>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />

      <DActivityActions
        v-if="isUserSignedIn && !isRepost"
        :activity="activity"
        @activity-removed="activityRemoved"
      />
    </div>

    <div class="activity-content">
      {{ activity.source.overview }}
    </div>

    <DActivityBook
      v-if="activity.source.book"
      :book="activity.source.book"
      class="space-top-2em"
      :has-video-review="!!activity.source.video_url"
      :is-user-signed-in="isUserSignedIn"
      :verdict="activity.source.verdict"
    />
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';

export default {
  mixins: [
    activityMixin,
  ],
};
</script>

